/**
 * @generated SignedSource<<0ce4a1008dc0aa4446dcce39648bfd85>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type initSupportChat_seller$data = {
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"initSierraChat_seller">;
  readonly " $fragmentType": "initSupportChat_seller";
};
export type initSupportChat_seller$key = {
  readonly " $data"?: initSupportChat_seller$data;
  readonly " $fragmentSpreads": FragmentRefs<"initSupportChat_seller">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "initSupportChat_seller"
};

(node as any).hash = "3ce852a64340f977e647a1408e9c004a";

export default node;
